module.exports = __webpack_public_path__ + "images/dashboard-delay-statistics@2x-4729dccd821976bb318820e492f56acc.png";